import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
// When a template is not editable, elements of the editor becomes disabled
export const DisabledContext = /*#__PURE__*/React.createContext({
  disabled: false,
  setDisabled: () => {}
});
export const DisabledContextProvider = ({
  template,
  children
}) => {
  const [disabled, setDisabled] = React.useState(!template?.editable);
  const disableContextValue = React.useMemo(() => ({
    disabled,
    setDisabled
  }), [disabled, setDisabled]);
  return /*#__PURE__*/_jsx(DisabledContext.Provider, {
    value: disableContextValue,
    children: children
  });
};